import React, { useState } from 'react';
import PropTypes from "prop-types";

import placeholderLogo from "~/assets/images/placeholder_logo.png";


const DemoIndexApp = (props) => {
    const [filters, setFilters] = useState([]);
    const [chair, setChair] = useState();
    const [researchAxis, setResearchAxis] = useState();

    const handleTechnicalUpdate = (event) => {
        if(event.target.checked) {
            setFilters([...filters.filter(el => el != "non-technical"), "technical"]);
            $("input[id='non-technical-btn']").prop("checked", false);
        }
        else setFilters(filters.filter(el => el != "technical"));
    };
    const handleNonTechnicalUpdate = (event) => {
        if(event.target.checked) {
            setFilters([...filters.filter(el => el != "technical"), "non-technical"]);
            $("input[id='technical-btn']").prop("checked", false);
        }
        else setFilters(filters.filter(el => el != "non-technical"));
    };
    const handleVideoUpdate = (event) => {
        if(event.target.checked) {
            setFilters([...filters.filter(el => el != "interactive"), "video"]);
            $("input[id='interactive-btn']").prop("checked", false);
        }
        else setFilters(filters.filter(el => el != "video"));
    };
    const handleInteractiveUpdate = (event) => {
        if(event.target.checked) {
            setFilters([...filters.filter(el => el != "video"), "interactive"]);
            $("input[id='video-btn']").prop("checked", false);
        }
        else setFilters(filters.filter(el => el != "interactive"));
    };
    const handleRestrictedUpdate = (event) => {
        if(event.target.checked) setFilters([...filters, "restricted"]);
        else setFilters(filters.filter(el => el != "restricted"));
    };
    
    const handleChairSelect = (chair) => {
        setChair(chair);
        setResearchAxis(demos.filter(demo => demo.chair == chair)[0].axis);
    };

    const demos = props.demos.filter(demo => (
            !(
                demo.target_users == "NON_TECHNICAL" && (filters.includes("technical")) ||
                demo.target_users == "TECHNICAL" && (filters.includes("non-technical"))
            ) && !(
                demo.type == "INTERACTIVE" && (filters.includes("video")) ||
                demo.type == "VIDEO" && (filters.includes("interactive"))
            ) && !(
                !demo.restricted && (filters.includes("restricted"))
            ) && !(chair && !(demo.chair == chair)) && !(researchAxis && !(demo.axis == researchAxis))
        )
    );

    const chairs = [...new Set(demos.map(demo => demo.chair))];
    const researchAxes = [...new Set(demos.map(demo => demo.axis))];

    return props.demos.length > 0 ? <>
        <div className = "d-flex justify-content-center align-items-center flex-wrap my-3">
            <div className = "btn-group mx-3 rounded-pill" role = "group">
                <input type = "checkbox" className = "btn-check active" id = "non-technical-btn" autoComplete = "off" onChange = { handleNonTechnicalUpdate } />
                <label className = "btn btn-outline-light rounded-start-pill" htmlFor = "non-technical-btn"><i className = "bi bi-people-fill me-1"></i>Non technical users</label>

                <input type = "checkbox" className = "btn-check" id = "technical-btn" autoComplete = "off" onChange = { handleTechnicalUpdate } />
                <label className = "btn btn-outline-light rounded-end-pill" htmlFor = "technical-btn"><i className = "bi bi-person-fill-gear me-1"></i>Technical users</label>
            </div>
            <div className = "btn-group mx-3" role = "group">
                <input type = "checkbox" className = "btn-check" id = "video-btn" autoComplete = "off" onChange = { handleVideoUpdate } />
                <label className = "btn btn-outline-light rounded-start-pill" htmlFor = "video-btn"><i className = "bi bi-camera-video-fill me-1"></i>Video</label>
                
                <input type = "checkbox" className = "btn-check" id = "interactive-btn" autoComplete = "off" onChange = { handleInteractiveUpdate } />
                <label className = "btn btn-outline-light rounded-end-pill" htmlFor = "interactive-btn"><i className = "bi bi-hand-index-fill me-1"></i>Interactive demo</label>
            </div>
            <input type = "checkbox" className = "btn-check" id = "restricted-btn" autoComplete = "off" onChange = { handleRestrictedUpdate } />
            <label className = "btn btn-outline-light rounded-pill" htmlFor = "restricted-btn"><i className = "bi bi-lock-fill me-1"></i>Restricted access</label>
        </div>
        <div className = 'd-flex justify-content-center align-items-center flex-wrap my-2'>
            {
                chair ? <div className = 'mx-3'>
                    <b>Chair: </b>&nbsp;{ chair }&nbsp;<a href = "#" className = 'link-light' onClick = { () => { setChair(); } }><i className = "bi bi-x-lg"></i></a>
                </div> :
                <div className = "dropdown mx-3">
                    <button className = "btn btn-outline-light dropdown-toggle rounded-0" type = "button" data-bs-toggle = "dropdown" aria-expanded = "false">
                        Chairs
                    </button>
                    <div className = "dropdown-menu p-0">
                        {
                            chairs.length > 0 ? <>
                                {
                                    chairs.map((chairLabel, i) => <div key = { i }>
                                        <a className = "dropdown-item" href = "#" onClick = { () => { handleChairSelect(chairLabel); } }>{ chairLabel }</a>
                                    </div>)
                                }
                            </> :
                            <small className = 'ps-2 fst-italic text-light'>No chairs available</small>
                        }
                    </div>
                </div>
            }
            {
                researchAxis ? <div className = 'mx-3'>
                    <b>Research axis: </b>&nbsp;{ researchAxis }&nbsp;<a href = "#" className = 'link-light' onClick = { () => { setResearchAxis(); } }><i className = "bi bi-x-lg"></i></a>
                </div> :
                <div className = "dropdown mx-3">
                    <button className = "btn btn-outline-light dropdown-toggle rounded-0" type = "button" data-bs-toggle = "dropdown" aria-expanded = "false">
                        Research axes
                    </button>
                    <div className = "dropdown-menu p-0">
                        {
                            researchAxes.length > 0 ? <>
                                {
                                    researchAxes.map((researchAxisLabel, i) => <div key = { i }>
                                        <a className = "dropdown-item" href = "#" onClick = { () => { setResearchAxis(researchAxisLabel); } }>{ researchAxisLabel }</a>
                                    </div>)
                                }
                            </> :
                            <small className = 'ps-2 fst-italic text-light'>No research axes available</small>
                        }
                    </div>
                </div>
            }
        </div>
        <div className = "d-flex flex-wrap justify-content-center align-items-center">
            {
                demos.length > 0 ? <>
                    {
                        demos.map(demo => <div key = { demo.id } className = "card m-3">
                            <img src = { demo.logo ? demo.logo : placeholderLogo } className = "img-fluid" alt = "..." />
                            <div className = "card-body">
                                <h5 className = "card-title text-truncate">{ demo.title }</h5>
                                <a href = { demo.url } className = "stretched-link"></a>
                                <div className = 'd-flex flex-wrap justify-content-center'>
                                    { demo.type == "INTERACTIVE" ? <i className = "bi bi-hand-index-fill px-2"></i> : <i className = "bi bi-camera-video-fill px-2"></i> }
                                    { demo.target_users == "TECHNICAL" ? <i className = "bi bi-person-fill-gear px-2"></i> : <i className = "bi bi-people-fill px-2"></i> }
                                    { demo.restricted ? <i className = "bi bi-lock-fill px-2"></i> : null }
                                </div>
                            </div>
                        </div>)
                    }
                </> :
                <p className = 'my-3'>No demos available with the selected filters</p>
            }
        </div>
    </> :
    <p className = "fst-italic my-5 text-center">
        No demos are currently available on our website.
    </p>;
};

DemoIndexApp.propTypes = {
    demos: PropTypes.arrayOf(PropTypes.object)
};

export default DemoIndexApp;
